export const isInvoicedStatus = (status?: string) =>
  status === "BILLED" || status === "INVOICE_GENERATED";

export const isOpenMemo = (status?: string) =>
  !status || status === "DRAFT" || status === "READY_FOR_BILLING";

export const statusLabel = (status?: string, type?: string) => {
  if (status === "READY_FOR_BILLING") return "Ready for billing";
  if (isInvoicedStatus(status)) {
    return type === "CREDIT" ? "Credit Note Confirmed" : "Invoice Confirmed";
  }
  if (status === "CANCELLED") return "Cancelled";
  if (status === "OUT_ON_APPROVAL") return "Out on approval";
  if (status === "CLOSED") return "Closed";
  return "Draft";
};
